import Steigenberg from '../assets/svg/experience/Steigenberg.svg';
import EdiQue from '../assets/svg/experience/Edique_fav.png';

export const experienceData = [
    {
        id: 1,
        company: 'EdiQue Solutions Private Limited',
        jobtitle: 'Full Stack Web Developer',
        startYear: 'June, 2023',
        endYear: 'Present',
        image: EdiQue,
        place: 'Advant Navis Business Park, Sector-142, Noida'
    },

    {
        id: 2,
        company: 'Steigenberg Creative Digital Agency',
        jobtitle: 'Full Stack Web Developer',
        startYear: 'Dec, 2020',
        endYear: 'June, 2023',
        image: Steigenberg,
        place: 'Nangloi Delhi'
    },
    // {
    //     id: 2,
    //     company: 'Vehement Capital Partners',
    //     jobtitle: 'Backend Developer',
    //     startYear: '2019',
    //     endYear: '2020'
    // },
    // {
    //     id: 3,
    //     company: 'Wonka Industries',
    //     jobtitle: 'Marketing',
    //     startYear: '2020',
    //     endYear: 'Present'
    // },
]